import { Box, Typography } from "@mui/material";
import { Dayjs } from "dayjs";

export default function OutOfMonthDayCell({ day }: { day: Dayjs }) {
  // TODO: clicking on cell should move to that month
  return (
    <Box
      sx={{
        border: "1px solid #e0e0e0",
        p: 1.5,
        backgroundColor: "#f9f9f9",
        minHeight: "120px",
        position: "relative",
        cursor: "pointer",
      }}
    >
      <Typography
        variant="body2"
        sx={(theme) => ({
          fontWeight: 500,
          color: theme.palette.text.disabled,
          mb: 0.5,
          ml: "auto",
          textAlign: "right",
        })}
      >
        {day.date()}
      </Typography>
    </Box>
  );
}
